// From https://usehooks.com
import { useState, useEffect } from "react"

export const useWindowSize = (): { height: number | undefined; width: number | undefined } => {
    const isClient = typeof window === "object"

    const getSize = (): { height: number | undefined; width: number | undefined } => {
        return {
            width: isClient ? window.innerWidth : undefined,
            height: isClient ? window.innerHeight : undefined,
        }
    }

    const [windowSize, setWindowSize] = useState(getSize)

    useEffect((): any => {
        if (!isClient) {
            return false
        }

        const handleResize = () => {
            setWindowSize(getSize())
        }

        window.addEventListener("resize", handleResize)

        return (): void => window.removeEventListener("resize", handleResize)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) // Empty array ensures that effect is only run on mount and unmount

    return windowSize
}
